  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import Checkbox                                            from '@material-ui/core/Checkbox';
  import Radio                                               from '@material-ui/core/Radio';
  import RadioGroup                                          from '@material-ui/core/RadioGroup';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
//import Select                                              from '@material-ui/core/Select';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //[POPOVER]
//import Popover                                             from '@material-ui/core/Popover';
//import IconButton                                          from '@material-ui/core/IconButton';
//import InputAdornment                                      from '@material-ui/core/InputAdornment';
//import Typography                                          from '@material-ui/core/Typography';
//import InfoIcon                                            from '@material-ui/icons/Info';
  //-------------------
  // @material-ui/icons
  //-------------------
//import CardTravel                                          from "@material-ui/icons/CardTravel";
//import Extension                                           from "@material-ui/icons/Extension";
//import Fingerprint                                         from "@material-ui/icons/Fingerprint";
//import FlightLand                                          from "@material-ui/icons/FlightLand";
//import Build                                               from "@material-ui/icons/Build";
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
//import TagManager                                          from 'react-gtm-module'
//import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
//import { wu_IdentityCardsService }                         from "../../_services";
//import { wu_TransactionFlow }                              from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
//import { wu_GeolocationService }                           from "../../_services";
//import { wu_RegisterGOVService }                           from "../../_services";
//import { wu_RegisterIdBoxService }                         from "../../_services";
  //------
  // Style
  //------
  import RegisterLight2Style                                      from "./RegisterLight2Style.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
//import img2                                                from "assets/img/wu/testImg2.png";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //[Campaign]
  import WU_popup_campaign_el                                from "assets/img/wu/popup_campaign_el.png";
  import WU_popup_campaign_en                                from "assets/img/wu/popup_campaign_en.png";
  //----------
  // variables
  //----------
  const filename = "RegisterLight2 ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  let birthDate_dv = "2000-01-01";

  // //[flagsimages]
  // var images = null;

class RegisterLight2 extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    let firstName = "";
    let lastName  = "";
    let birthDate = birthDate_dv;

    // if(api.prefil_RegisterLight2ViewController){
    //   firstName = "SOTIRIS";
    //   lastName  = "MENIS";
    //   birthDate = "1980-01-01";
    // }

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //popup bpdone
      dialog_bpdone_msg                                    : "",
      dialog_bpdone_isOpen                                 : false,

      //[HONEYMOON]
      textField0                                           : "", //4279034659
      textField0_hasError                                  : false,

      firstName                                            : firstName,   //TextField
      firstName_disabled                                   : false,
      firstName_hasError                                   : false,
      lastName                                             : lastName,    //TextField
      lastName_disabled                                    : false,
      lastName_hasError                                    : false,
      idNumber                                             : "",          //TextField
      idNumber_hasError                                    : false,
      idNumber_isHidden                                    : false,
      birthDate                                            : birthDate,   //DatePicker
      birthDate_disabled                                   : false,
      birthDate_hasError                                   : false,
      birthDate_isHidden                                   : false,

      lbl_lbl2_newCustomer_full_isHidden                   : true,

      parserObject_getCountries                            : [],
      parserObject_getCountries4Picker                     : [],
      parserObject_getLanguages                            : [],
      parserObject_getLanguages4Picker                     : [],
      parserObject_getPhonePrefixes                        : [],
      parserObject_getPhonePrefixes4Picker                 : [],

      parserObject_getDays                                 : [],
      parserObject_getMonths                               : [],
      parserObject_getYears                                : [],

      birthDateDay_text                                    : "",          //DropDown
    //birthDateDay_id                                      : "",
      birthDateDay_disabled                                : false,
      birthDateDay_hasError                                : false,
      birthDateMonth_text                                  : "",          //DropDown
    //birthDateMonth_id                                    : "",
      birthDateMonth_disabled                              : false,
      birthDateMonth_hasError                              : false,
      birthDateYear_text                                   : "",          //DropDown
    //birthDateYear_id                                     : "",
      birthDateYear_disabled                               : false,
      birthDateYear_hasError                               : false,

      //BP_FUNCTIONALLITY_ENABLED(checkBox)
      userCheckedTick                                      : false,
      view_checkbox_isHidden                               : true,
      //BP_FUNCTIONALLITY_ENABLED(Radio)
      view_radioButtons_isHidden                           : false,
      radioButtonsValue                                   : "BP",
      bool_sel1                                            : true,
      bool_sel2                                            : false,

      //[Campaign]
      dialog101_msg                                        : "",
      dialog101_isOpen                                     : false,
      dialog101_campaign_image_w                           : "512",
      dialog101_campaign_image_h                           : "268",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                        = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                       = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                                      = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                               = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                              = this.Snackbar_textField_handleClose.bind(this);

    this.btn_next_act                                                = this.btn_next_act.bind(this);
    this.btn_next_act_isDisabled                                     = this.btn_next_act_isDisabled.bind(this);

    this.handleSubmit_with_recaptcha                                 = this.handleSubmit_with_recaptcha.bind(this);
    this.recaptchaRef                                                = React.createRef();

    this.handleCustomDropDownClick_birthDateDay                      = this.handleCustomDropDownClick_birthDateDay.bind(this);
    this.handleCustomDropDownClick_birthDateMonth                    = this.handleCustomDropDownClick_birthDateMonth.bind(this);
    this.handleCustomDropDownClick_birthDateYear                     = this.handleCustomDropDownClick_birthDateYear.bind(this);
    this.checkBirthDate                                              = this.checkBirthDate.bind(this);

    //popup bpdone
    this.dialog_bpdone_handleOpen                                    = this.dialog_bpdone_handleOpen.bind(this);
    this.dialog_bpdone_btn_ok                                        = this.dialog_bpdone_btn_ok.bind(this);

    //BP_FUNCTIONALLITY_ENABLED(checkBox)
    this.handleCheckBoxClick_BillPayment                             = this.handleCheckBoxClick_BillPayment.bind(this);
    //BP_FUNCTIONALLITY_ENABLED(Radio)
    this.handleRadioButtonClick_BillPayment                          = this.handleRadioButtonClick_BillPayment.bind(this);

    //[SAVE STATE]
    this.saveState                                                   = this.saveState.bind(this);

    //[CAMPAIGN]
    this.dialog101_handleOpen                                        = this.dialog101_handleOpen.bind(this);
    this.dialog101_handleClose                                       = this.dialog101_handleClose.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    if(api.print_logs){console.log(methName+localStorage.getItem("curr_view")+",history.length="+history.length);}

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }

    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}

    if(localStorage.getItem("prev_view").trim()==="RegisterLight3"){
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){;}
      return;
    }

    // let currYear = parseInt((new Date()).getFullYear());
    // let parserObject_getDays_TMP   = [];
    // let parserObject_getMonths_TMP = [];
    // let parserObject_getYears_TMP  = [];
    // for(let i=1;            i<32;            ++i){parserObject_getDays_TMP.push(i.toString());}
    // for(let i=1;            i<13;            ++i){parserObject_getMonths_TMP.push(i.toString());}
    // for(let i=currYear-100; i<currYear-18+1; ++i){parserObject_getYears_TMP.push(i.toString());}
    // this.setState({
    //   "parserObject_getDays"   : parserObject_getDays_TMP,
    //   "parserObject_getMonths" : parserObject_getMonths_TMP,
    //   "parserObject_getYears"  : parserObject_getYears_TMP,
    // });
    let currYear = parseInt((new Date()).getFullYear());
    let parserObject_getDays_TMP   = [];
    let parserObject_getMonths_TMP = [];
    let parserObject_getYears_TMP  = [];
    for(let i=1;            i<32;            ++i){parserObject_getDays_TMP.push(  i<10 ? "0"+i.toString() : i.toString());}
    for(let i=1;            i<13;            ++i){parserObject_getMonths_TMP.push(i<10 ? "0"+i.toString() : i.toString());}
    for(let i=currYear-100; i<currYear-18+1; ++i){parserObject_getYears_TMP.push(i.toString());}
    this.setState({
      "parserObject_getDays"   : parserObject_getDays_TMP,
      "parserObject_getMonths" : parserObject_getMonths_TMP,
      "parserObject_getYears"  : parserObject_getYears_TMP,
    });

    // //[flagsimages]
    // images = this.importAll(require.context('assets/img/flagspng/', false, /\.(png|svg)$/));
    // //if(api.print_logs){console.log("images.length="+images.length);}
    // //for (var key in images) { if(api.print_logs){console.log("key="+key);} }

    //this.startSpinners();
    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        var parserObject_getCountries4Picker = [];
        //res.countries = this.removeNonWuCountries(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        //res.countries = this.removeNonWuCountries(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        //res.countries = this.removeNonWuCountries(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      }catch(err){
        console.log('err='+err);
      }
    }
    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    //-------------------
    //wu_validatecustomer
    //-------------------
    wu_ProfileService
    .wu_validatecustomer({})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="RegisterLight2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));
    })
    .catch(err => {
      this.stopSpinners();
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });

    let newRegistrationFlow = "";
    try{ newRegistrationFlow = localStorage.getItem("newRegistrationFlow");}catch(err){console.log(methName+'err='+err);}
    if(newRegistrationFlow === "changeId"){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let ws_firstName         = "";
      let ws_lastName          = "";
      let ws_birthDate         = "";
      try {ws_firstName         = parserObject_validatecustomer["fname"];             }catch(err){;} if(ws_firstName         === null || (typeof ws_firstName         ==="undefined")){ws_firstName         = "";}
      try {ws_lastName          = parserObject_validatecustomer["lname"];             }catch(err){;} if(ws_lastName          === null || (typeof ws_lastName          ==="undefined")){ws_lastName          = "";}
      try {ws_birthDate         = parserObject_validatecustomer["birth_date"];        }catch(err){;} if(ws_birthDate         === null || (typeof ws_birthDate         ==="undefined")){ws_birthDate         = "";}
      let ws_birthDateDay   = "";
      let ws_birthDateMonth = "";
      let ws_birthDateYear  = "";
      if(ws_birthDate!==""){
        try {ws_birthDateDay   = ws_birthDate.substring(8, 8+2); }catch(err){;} if(ws_birthDateDay   === null || (typeof ws_birthDateDay   ==="undefined")){ws_birthDateDay   = "";}
        try {ws_birthDateMonth = ws_birthDate.substring(5, 5+2); }catch(err){;} if(ws_birthDateMonth === null || (typeof ws_birthDateMonth ==="undefined")){ws_birthDateMonth = "";}
        try {ws_birthDateYear  = ws_birthDate.substring(0, 0+4); }catch(err){;} if(ws_birthDateYear  === null || (typeof ws_birthDateYear   ==="undefined")){ws_birthDateYear = "";}
      }
      this.setState({
        firstName                                            : ws_firstName, //TextField
        firstName_disabled                                   : true,
        firstName_hasError                                   : false,
        lastName                                             : ws_lastName,  //TextField
        lastName_disabled                                    : true,
        lastName_hasError                                    : false,
        idNumber                                             : "",           //TextField
        idNumber_hasError                                    : false,
        birthDate                                            : ws_birthDate, //DatePicker
        birthDate_disabled                                   : true,
        birthDate_hasError                                   : false,

        birthDateDay_text                                    : ws_birthDateDay,
      //birthDateDay_id                                      : "",
        birthDateDay_disabled                                : ws_birthDate===""   ? false : true,
        birthDateDay_hasError                                : false,
        birthDateMonth_text                                  : ws_birthDateMonth,
      //birthDateMonth_id                                    : "",
        birthDateMonth_disabled                              : ws_birthDate===""   ? false : true,
        birthDateMonth_hasError                              : false,
        birthDateYear_text                                   : ws_birthDateYear,
      //birthDateYear_id                                     : "",
        birthDateYear_disabled                               : ws_birthDate===""   ? false : true,
        birthDateYear_hasError                               : false,
      });
    }
    else{
      this.setState({
        firstName                                            : "",           //TextField
        firstName_disabled                                   : false,
        firstName_hasError                                   : false,
        lastName                                             : "",           //TextField
        lastName_disabled                                    : false,
        lastName_hasError                                    : false,
        idNumber                                             : "",           //TextField
        idNumber_hasError                                    : false,
        birthDate                                            : "",           //TextField
        birthDate_disabled                                   : false,
        birthDate_hasError                                   : false,

        birthDateDay_text                                    : "",
      //birthDateDay_id                                      : "",
        birthDateDay_disabled                                : false,
        birthDateDay_hasError                                : false,
        birthDateMonth_text                                  : "",
      //birthDateMonth_id                                    : "",
        birthDateMonth_disabled                              : false,
        birthDateMonth_hasError                              : false,
        birthDateYear_text                                   : "",
      //birthDateYear_id                                     : "",
        birthDateYear_disabled                               : false,
        birthDateYear_hasError                               : false,
      });
    }
    //-------------------------
    //BP_FUNCTIONALLITY_ENABLED
    //-------------------------
    if(api.BP_FUNCTIONALLITY_ENABLED){
      if(newRegistrationFlow === "newCustomer"){ this.setState({ view_checkbox_isHidden : true, view_radioButtons_isHidden:false, idNumber_isHidden:true,  birthDate_isHidden:true,  lbl_lbl2_newCustomer_full_isHidden: false,}); } //lbl_lbl2_newCustomer_full_isHidden: true
      else                                     { this.setState({ view_checkbox_isHidden : true, view_radioButtons_isHidden:true,  idNumber_isHidden:false, birthDate_isHidden:false, lbl_lbl2_newCustomer_full_isHidden: false,}); } //lbl_lbl2_newCustomer_full_isHidden: true
    }
    else{
      this.setState({ view_checkbox_isHidden : true, view_radioButtons_isHidden:true, idNumber_isHidden:false, birthDate_isHidden:false, lbl_lbl2_newCustomer_full_isHidden: false,});
    }

    //[CAMPAIGN]
    //wu_Utilities.campaign_clear_statsView(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,filename.trim());
    wu_Utilities.campaign_record_load(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim());
    if(wu_Utilities.campaign_should_show(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim())===true){
      console.log("campaigns window.innerWidth="+window.innerWidth);
      if(window.innerWidth > 960){ this.setState({"dialog101_campaign_image_w":"512","dialog101_campaign_image_h":"268",}); }
      else                       { this.setState({"dialog101_campaign_image_w":"256","dialog101_campaign_image_h":"134",}); }
      this.dialog101_handleOpen("");
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    const defaultPropsDay = {
      options        : this.state.parserObject_getDays,
      getOptionLabel : option => option,
    };
    const defaultPropsMonth = {
      options        : this.state.parserObject_getMonths,
      getOptionLabel : option => option,
    };
    const defaultPropsYear = {
      options        : this.state.parserObject_getYears,
      getOptionLabel : option => option,
    };

    var newRegistrationFlow = "";
    try { newRegistrationFlow = localStorage.getItem("newRegistrationFlow"); } catch(err){;}
    var screen_title = "";
    if(newRegistrationFlow === "newCustomer")   { screen_title = this.NSInforString("RegisterLight2_title_newCustomer"); }
    if(newRegistrationFlow === "upgradeAccount"){ screen_title = this.NSInforString("RegisterLight2_title_upgradeAccount"); }
    if(newRegistrationFlow === "changeId")      { screen_title = this.NSInforString("RegisterLight2_title_changeId"); }
    let RegisterLight2_viewInfo_lbl_lbl1 = "";
    if(newRegistrationFlow === "newCustomer")   { RegisterLight2_viewInfo_lbl_lbl1 = this.NSInforString("RegisterLight2_viewInfo_lbl_lbl1_newCustomer"); }
    if(newRegistrationFlow === "upgradeAccount"){ RegisterLight2_viewInfo_lbl_lbl1 = this.NSInforString("RegisterLight2_viewInfo_lbl_lbl1_upgradeAccount"); }
    if(newRegistrationFlow === "changeId")      { RegisterLight2_viewInfo_lbl_lbl1 = this.NSInforString("RegisterLight2_viewInfo_lbl_lbl1_changeId"); }
    var RegisterLight2_viewInfo_lbl_lbl2 = this.NSInforString("RegisterLight2_viewInfo_lbl_lbl2");

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{screen_title}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{screen_title}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}

            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.label1}>{RegisterLight2_viewInfo_lbl_lbl1}</div>
                <div style={{ marginBottom:10 }}></div>
              </GridItem>
            </GridContainer>

            <GridContainer justify="center">
              {/* ------------------------- */}
              {/* ----------[HONEYMOON]---- */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                  <TextField
                    fullWidth
                    autoComplete={this.autoCompleteText_Textfields()}
                    error={this.state.textField0_hasError}
                    className={classes.textField0}
                    id={this.autoCompleteText_Textfields()}
                    label={this.autoCompleteText_Textfields()}
                    value={this.state.textField0}
                    InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                  />
              </GridItem>
              {/* ---------------------------------------------------------- */}
              {/* ----------//BP_FUNCTIONALLITY_ENABLED(Radio)-------------- */}
              {/* ---------------------------------------------------------- */}
              {this.state.view_radioButtons_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                <div style={{ marginTop:0, marginBottom:0}}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <RadioGroup aria-label="gender" name="gender1" value={this.state.radioButtonsValue} onChange={this.handleRadioButtonClick_BillPayment} row={true}>
                        <GridItem xs={12} sm={12} md={12} style={{marginLeft:-10, padding:0}}><FormControlLabel value="BP" control={<Radio />} label={this.NSInforString("RegisterLight2_lbl_radio_BP")} /></GridItem>
                        <GridItem xs={12} sm={12} md={12} style={{marginLeft:-10, padding:0}}><FormControlLabel value="WU" control={<Radio />} label={this.NSInforString("RegisterLight2_lbl_radio_WU")} /></GridItem>
                      </RadioGroup>
                    </GridItem>
                  </GridContainer>
                </div>
                </GridItem>
              )}
              {this.state.lbl_lbl2_newCustomer_full_isHidden === true ? ( "" ) : (
                  <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop:10, marginBottom:0, textAlign:"left"}}>
                    <div className={classes.label1}>{RegisterLight2_viewInfo_lbl_lbl2}</div>
                    <div style={{ marginBottom:0 }}></div>
                  </div>
                  </GridItem>
              )}
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error   ={this.state.firstName_hasError}
                  disabled={this.state.firstName_disabled}
                  className={classes.firstName}
                  id="firstName"
                  label={this.NSInforString("RegisterLight2_plh01")}
                  value={this.state.firstName}
                  InputProps={{
                    fullWidth: true,
                    onChange: event => this.change(event, "firstName"),
                    type: "text",
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error   ={this.state.lastName_hasError}
                  disabled={this.state.lastName_disabled}
                  className={classes.lastName}
                  id="lastName"
                  label={this.NSInforString("RegisterLight2_plh02")}
                  value={this.state.lastName}
                  InputProps={{
                    fullWidth: true,
                    onChange: event => this.change(event, "lastName"),
                    type: "text"
                  }}
                />
              </GridItem>
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {this.state.idNumber_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.idNumber_hasError}
                    className={classes.idNumber}
                    id="idNumber"
                    label={this.NSInforString("RegisterLight2_plh03")}
                    value={this.state.idNumber}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "idNumber"),
                      type: "text"
                    }}
                  />
                </GridItem>
              )}
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={12}>
                <div style={{ marginTop:10 }}></div>
              </GridItem>
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {this.state.birthDate_isHidden === true ? ( "" ) : (
              <GridItem xs={12} sm={12} md={12}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12} style={{ marginBottom:0,marginTop:0 }}>
                      <div className={classes.label1}>{this.NSInforString("RegisterLight2_plh04")}</div>
                  </GridItem>
                  <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_d}>
                    <FormControl fullWidth className={classes.birthDateDay}>
                      <Autocomplete
                        {...defaultPropsDay}
                        disabled={this.state.birthDateDay_disabled}
                        id="birthDateDayId"
                        value={this.state.birthDateDay_text}
                        disableClearable
                        onChange={(event,value) => this.handleCustomDropDownClick_birthDateDay(event,value)}
                        renderInput={params => <TextField {...params} error={this.state.birthDateDay_hasError} label={this.NSInforString("RegisterLight2_plh04_d")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_m}>
                    <FormControl fullWidth className={classes.birthDateMonth}>
                      <Autocomplete
                        {...defaultPropsMonth}
                        disabled={this.state.birthDateMonth_disabled}
                        id="birthDateMonthId"
                        value={this.state.birthDateMonth_text}
                        disableClearable
                        onChange={(event,value) => this.handleCustomDropDownClick_birthDateMonth(event,value)}
                        renderInput={params => <TextField {...params} error={this.state.birthDateMonth_hasError} label={this.NSInforString("RegisterLight2_plh04_m")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_y}>
                    <FormControl fullWidth className={classes.birthDateYear}>
                      <Autocomplete
                        {...defaultPropsYear}
                        disabled={this.state.birthDateYear_disabled}
                        id="birthDateYearId"
                        value={this.state.birthDateYear_text}
                        disableClearable
                        onChange={(event,value) => this.handleCustomDropDownClick_birthDateYear(event,value)}
                        renderInput={params => <TextField {...params} error={this.state.birthDateYear_hasError} label={this.NSInforString("RegisterLight2_plh04_y")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem xs={6} sm={6} md={6}>
                  </GridItem>
                </GridContainer>
              </GridItem>
              )}
              {/* ---------------------------------------------------------- */}
              {/* ----------//BP_FUNCTIONALLITY_ENABLED(checkbpox)---------- */}
              {/* ---------------------------------------------------------- */}
              {this.state.view_checkbox_isHidden === true ? ( "" ) : (
                <div style={{ marginLeft:10 }}>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={this.handleCheckBoxClick_BillPayment}
                            value="checkedA"
                            inputProps={{ 'aria-label': 'Checkbox A' }}
                          />
                        }
                        label={this.NSInforString("RegisterLight2_lbl_checkTick")}
                      />
                    </GridItem>
                </GridContainer>
                </div>
              )}

            </GridContainer>
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <div>
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.labelHeader}>&nbsp;</div>
                  <div className={classes.textCenter}>
                    {/* <ReCAPTCHA
                      ref={ ref => this.recaptchaRef = ref }
                      locale={localStorage.getItem("lang")}
                      sitekey={api.captchKey}
                      onResolved={ this.btn_next_act } /> */}
                    <CustomButton
                      disabled={this.btn_next_act_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.btn_next_act}
                      type="submit">
                      {this.NSInforString("RegisterLight2_btn_next") }
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
              {/* -------------------------------------------------- */}
              {/* ----------[goBack Bottom]------------------------- */}
              {/* -------------------------------------------------- */}
              {api.backButtonAtBottom === true ? (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    <div className={classes.textCenter}>
                      <CustomButton
                        disabled={false}
                        className={classes.backButton}
                        color="rose"
                        onClick={this.goBack}>
                        {this.NSInforString("RegisterLight2_btn_prev")}
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              ) : ( "" ) }
            </div>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={3000} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------------------- */}
        {/* ----------[POPUP bpdone]---------------- */}
        {/* ---------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_bpdone_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_bpdone_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_bpdone_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_bpdone} color="default" onClick={this.dialog_bpdone_btn_ok}>{this.NSInforString("alert_OK")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
        {/* ------------------------------ */}
        {/* ----------[POPUP][CAMPAIGN]--- */}
        {/* ------------------------------ */}
        <div>
          <Dialog
            open={this.state.dialog101_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog101_handleClose}
            aria-labelledby="alert-dialog101-slide-title"
            aria-describedby="alert-dialog101-slide-description"
          >
            <DialogTitle id="alert-dialog101-slide-title">{api.popup_tile}</DialogTitle>
            {localStorage.getItem("lang")==="el" ? (
              <DialogContent><img src={WU_popup_campaign_el} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            ) : (
              <DialogContent><img src={WU_popup_campaign_en} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            )}
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog101_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_birthDateDay(event,value) {
    let methName = filename+"handleCustomDropDownClick_birthDateDay ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({ "birthDateDay_text":eventTMP, "birthDateDay_hasError" : false,"birthDateMonth_hasError" : false, "birthDateYear_hasError" : false  });

    this.checkBirthDate("day",eventTMP);
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_birthDateMonth(event,value) {
    let methName = filename+"handleCustomDropDownClick_birthDateMonth ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({ "birthDateMonth_text":eventTMP, "birthDateDay_hasError" : false,"birthDateMonth_hasError" : false, "birthDateYear_hasError" : false  });

    this.checkBirthDate("month",eventTMP);
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_birthDateYear(event,value) {
    let methName = filename+"handleCustomDropDownClick_birthDateYear ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({ "birthDateYear_text":eventTMP, "birthDateDay_hasError" : false,"birthDateMonth_hasError" : false, "birthDateYear_hasError" : false  });

    this.checkBirthDate("year",eventTMP);
  }
  //----------------------------------------------------------------------------------------------------
  checkBirthDate(lastSelected_key,lastSelected_val){
    let methName = filename+"checkBirthDate ";

    let dddd_TMP = "";
    let mmmm_TMP = "";
    let yyyy_TMP = "";
    if(lastSelected_key==="day"  ){ if(this.state.birthDateMonth_text === "" || this.state.birthDateYear_text  === ""){ return; } dddd_TMP = lastSelected_val; mmmm_TMP = this.state.birthDateMonth_text; yyyy_TMP = this.state.birthDateYear_text;  }
    if(lastSelected_key==="month"){ if(this.state.birthDateDay_text   === "" || this.state.birthDateYear_text  === ""){ return; } mmmm_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay_text;   yyyy_TMP = this.state.birthDateYear_text;  }
    if(lastSelected_key==="year" ){ if(this.state.birthDateDay_text   === "" || this.state.birthDateMonth_text === ""){ return; } yyyy_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay_text;   mmmm_TMP = this.state.birthDateMonth_text; }

    let birthdate = "";
    let yyyy = yyyy_TMP;
    let mmmm = mmmm_TMP.length===1 ? "0"+mmmm_TMP : mmmm_TMP;
    let dddd = dddd_TMP.length===1 ? "0"+dddd_TMP : dddd_TMP;
    let isValidDate = this.isValidDate(yyyy_TMP,mmmm_TMP,dddd_TMP); //console.log("isValidDate="+isValidDate);
    if(isValidDate===false){
      this.setState({"birthDateDay_hasError" : true,"birthDateMonth_hasError" : true, "birthDateYear_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("NotValidDate"));
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    birthdate = yyyy+"-"+mmmm+"-"+dddd;
    try{
      let d1 = new Date(); d1.setFullYear( d1.getFullYear() - 18 );
      let d2 = new Date(birthdate);
      if(d1.getTime() < d2.getTime()){
        this.setState({"birthDateDay_hasError" : true,"birthDateMonth_hasError" : true, "birthDateYear_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("birthdate_error_age"));
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------CheckBox Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCheckBoxClick_BillPayment(event) {
    let methName = filename+"handleCheckBoxClick_BillPayment ";
    if(api.print_logs){console.log(methName+event.target.checked);}
    this.setState({
      "userCheckedTick"     : event.target.checked,
      "idNumber_isHidden"   : event.target.checked===true? true : false,
      "birthDate_isHidden"  : event.target.checked===true? true : false,
      "lbl_lbl2_newCustomer_full_isHidden":false,//"lbl_lbl2_newCustomer_full_isHidden": event.target.checked===true? true : false,
    });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------RadioButton Listeners-----------------------------
  //----------------------------------------------------------------------------------------------------
  //Consent-offers
  handleRadioButtonClick_BillPayment(event) {
    let methName = filename+"handleRadioButtonClick_BillPayment ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}

    if(eventTMP==="BP"){
      this.setState({
        "radioButtonsValue"  : eventTMP,
        "idNumber_isHidden"  : true,
        "birthDate_isHidden" : true,
        "lbl_lbl2_newCustomer_full_isHidden": false,//true,
        "bool_sel1"          : true,
        "bool_sel2"          : false,
      });
    }
    else{
      this.setState({
        "radioButtonsValue"  : eventTMP,
        "idNumber_isHidden"  : false,
        "birthDate_isHidden" : false,
        "lbl_lbl2_newCustomer_full_isHidden": false,//true,
        "bool_sel1"          : false,
        "bool_sel2"          : true,
      });
    }

    setTimeout(function() {
      this.saveState();
    }.bind(this), 250);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_next_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit_with_recaptcha(event) {
    let methName = filename+"handleSubmit_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.firstName.trim() === "")     { this.setState({"firstName_hasError" : true }); emptyFields = true; }
      if(this.state.lastName.trim() === "")      { this.setState({"lastName_hasError"  : true }); emptyFields = true; }
      if(this.state.idNumber.trim() === "")      { this.setState({"idNumber_hasError" : true }); emptyFields = true; }

      if(this.state.birthDateDay_text   === ""){ this.setState({"birthDateDay_hasError"   : true }); emptyFields = true; }
      if(this.state.birthDateMonth_text === ""){ this.setState({"birthDateMonth_hasError" : true }); emptyFields = true; }
      if(this.state.birthDateYear_text  === ""){ this.setState({"birthDateYear_hasError"  : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.btn_next_act_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act(event) {
    let methName = filename+"btn_next_act ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    let newRegistrationFlow = "";
    try{ newRegistrationFlow = localStorage.getItem("newRegistrationFlow");}catch(err){console.log(methName+'err='+err);}
    //-------------------------
    //BP_FUNCTIONALLITY_ENABLED
    //-------------------------
    if(api.BP_FUNCTIONALLITY_ENABLED && newRegistrationFlow === "newCustomer" && this.state.bool_sel1===true){
      //++++++++++++++++++++++
      //webapp session timeout
      //++++++++++++++++++++++
      if(wu_Utilities.checkIfUserIsLoggedIn()){
        wu_Utilities.update_uilatstats();
        if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
      }
      //+++++++++++++++++++++++
      //validate Only Emptyness
      //+++++++++++++++++++++++
      let validateOnlyEmptyness = true;
      if(validateOnlyEmptyness){
        let emptyFields = false;
        if(this.state.firstName.trim() === "")     { this.setState({"firstName_hasError" : true }); emptyFields = true; }
        if(this.state.lastName.trim() === "")      { this.setState({"lastName_hasError"  : true }); emptyFields = true; }
        if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
      }
      //+++++++++++++
      //validate Data
      //+++++++++++++
      //----------------------
      //validate Radio Buttons
      //----------------------
      if(this.state.bool_sel1===false  && this.state.bool_sel2===false){
        this.setState({"firstName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight2_BP_or_WU_err")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      //------------------
      //validate firstName---TextField
      //------------------
      let firstName      = this.state.firstName.trim();
      let textField1text = this.state.firstName.trim();
      if(textField1text === ""){
        this.setState({"firstName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight2_plh01")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      if(wu_Utilities.offline_validate_latinCharacters(textField1text.replace(/ /g,""))===false){
        this.setState({"firstName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight2_plh01")+"\" "+this.NSInforString("with_latin"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      if(textField1text.length < 2 || textField1text.length > 36){
        this.setState({"firstName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.firstName.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      //-----------------
      //validate lastName---TextField
      //-----------------
      let lastName       = this.state.lastName.trim();
      let textField2text = this.state.lastName.trim();
      if(textField2text === ""){
        this.setState({"lastName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight2_plh02")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      if(wu_Utilities.offline_validate_latinCharacters(textField2text.replace(/ /g,""))===false){
        this.setState({"lastName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight2_plh02")+"\" "+this.NSInforString("with_latin"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      if(textField2text.length < 2 || textField2text.length > 36){
        this.setState({"lastName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.lastName.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      //---------------------------
      //validate firstName+lastName---TextField
      //---------------------------
      if(textField1text.length + textField2text.length > 39){
        this.setState({"firstName_hasError" : true });
        this.setState({"lastName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.firstlastName.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      //++++++++++++++++++++
      //validate [HONEYMOON]
      //++++++++++++++++++++
      if(this.state.textField0.trim()!==""){
        //this.setState({"textField1_hasError" : true });
        if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      //++++++++
      //Continue
      //++++++++
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let email = "";
      try {email = parserObject_validatecustomer["email"]; }catch(err){;} if(email === null){email = "";}
      let newRegistrationFlow = "";
      try{ newRegistrationFlow = localStorage.getItem("newRegistrationFlow");}catch(err){console.log(methName+'err='+err);}
      let emailBase64 = new Buffer(email.trim()).toString('base64');

      //event.preventDefault();
      let parserObject_updateCustomerData_req = {};
      parserObject_updateCustomerData_req["step"]               = "2BP";                        //2
      parserObject_updateCustomerData_req["flow"]               = newRegistrationFlow;          //newCustomer, upgradeAccount, changeId, annualUpdate
      parserObject_updateCustomerData_req["email"]              = emailBase64;                  //Base64 lala@lala.com
      parserObject_updateCustomerData_req["hasBP"]              = "1";                          //"1","0"
      parserObject_updateCustomerData_req["firstName"]          = firstName;                    //Nikos
      parserObject_updateCustomerData_req["lastName"]           = lastName;                     //Menis
      parserObject_updateCustomerData_req["recaptchaVerify"]    = api.isCaptchaEnabled ? JSON.stringify(this.recaptchaRef.getResponse()) : "";

      this.startSpinners();
      setTimeout(function() { //Start the timer
        //------------------
        //updateCustomerData
        //------------------
        wu_ProfileService
        .wu_updateCustomerData(parserObject_updateCustomerData_req)
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="RegisterLight2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          //this.stopSpinners();
          //-------------------
          //wu_validatecustomer
          //-------------------
          wu_ProfileService
          .wu_validatecustomer({})
          .then(res => {
            if(localStorage.getItem("curr_view").trim()!=="RegisterLight2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
            this.stopSpinners();
            localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

            var pendingDataConfirmation = 0;
            var idVerificationStatus    = 0;
            var idExpired               = false;
            var hasBP                   = null;
            try {pendingDataConfirmation = parserObject_validatecustomer["pendingDataConfirmation"]; }catch(err){;} if(pendingDataConfirmation === null){pendingDataConfirmation = 0; }
            try {idVerificationStatus    = parserObject_validatecustomer["idVerificationStatus"];    }catch(err){;} if(idVerificationStatus    === null){idVerificationStatus    = 0; }
            try {idExpired               = parserObject_validatecustomer["idExpired"];               }catch(err){;} if(idExpired               === null){idExpired               = false; }
            try {hasBP                   = parserObject_validatecustomer["hasBP"];                   }catch(err){;} if(hasBP                   === null){hasBP                   = null; }
            if(api.print_logs){console.log(methName+"pendingDataConfirmation = "+pendingDataConfirmation);}
            if(api.print_logs){console.log(methName+"idVerificationStatus    = "+idVerificationStatus);}
            if(api.print_logs){console.log(methName+"idExpired               = "+idExpired);}
            if(api.print_logs){console.log(methName+"hasBP                   = "+hasBP);}
            //+++++++++++++++
            //Goto Controller
            //+++++++++++++++
            localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
            //history.push(wu_Utilities.getNavigationURLs("RegisterLightEndBP"));//btn_next_act xxx
            //this.dialog_bpdone_handleOpen(this.NSInforString("RegisterLight2_bpdone"),"NET");
            localStorage.setItem("registerLight2_to_bills_showPopup", "true");
            history.push(wu_Utilities.getNavigationURLs("Bills"));
          })
          .catch(err => {
            this.stopSpinners();
            console.log(methName+"err="+JSON.stringify(err));
            if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
            else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
          });
        })
        .catch(err => {
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });
      }.bind(this), 500);
    }
    else{
      //++++++++++++++++++++++
      //webapp session timeout
      //++++++++++++++++++++++
      if(wu_Utilities.checkIfUserIsLoggedIn()){
        wu_Utilities.update_uilatstats();
        if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
      }
      //+++++++++++++++++++++++
      //validate Only Emptyness
      //+++++++++++++++++++++++
      let validateOnlyEmptyness = true;
      if(validateOnlyEmptyness){
        let emptyFields = false;
        if(this.state.firstName.trim() === "")     { this.setState({"firstName_hasError" : true }); emptyFields = true; }
        if(this.state.lastName.trim() === "")      { this.setState({"lastName_hasError"  : true }); emptyFields = true; }
        if(this.state.idNumber.trim() === "")      { this.setState({"idNumber_hasError"  : true }); emptyFields = true; }

        if(this.state.birthDateDay_text   === ""){ this.setState({"birthDateDay_hasError"   : true }); emptyFields = true; }
        if(this.state.birthDateMonth_text === ""){ this.setState({"birthDateMonth_hasError" : true }); emptyFields = true; }
        if(this.state.birthDateYear_text  === ""){ this.setState({"birthDateYear_hasError"  : true }); emptyFields = true; }
        if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
      }
      //+++++++++++++
      //validate Data
      //+++++++++++++
      //------------------
      //validate firstName---TextField
      //------------------
      let firstName      = this.state.firstName.trim();
      let textField1text = this.state.firstName.trim();
      if(textField1text === ""){
        this.setState({"firstName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight2_plh01")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      if(wu_Utilities.offline_validate_latinCharacters(textField1text.replace(/ /g,""))===false){
        this.setState({"firstName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight2_plh01")+"\" "+this.NSInforString("with_latin"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      if(textField1text.length < 2 || textField1text.length > 36){
        this.setState({"firstName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.firstName.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      //-----------------
      //validate lastName---TextField
      //-----------------
      let lastName       = this.state.lastName.trim();
      let textField2text = this.state.lastName.trim();
      if(textField2text === ""){
        this.setState({"lastName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight2_plh02")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      if(wu_Utilities.offline_validate_latinCharacters(textField2text.replace(/ /g,""))===false){
        this.setState({"lastName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight2_plh02")+"\" "+this.NSInforString("with_latin"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      if(textField2text.length < 2 || textField2text.length > 36){
        this.setState({"lastName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.lastName.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      //---------------------------
      //validate firstName+lastName---TextField
      //---------------------------
      if(textField1text.length + textField2text.length > 39){
        this.setState({"firstName_hasError" : true });
        this.setState({"lastName_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.firstlastName.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      //--------------
      //validate idnum---TextField
      //--------------
      let idnum = this.state.idNumber.trim();
      if(idnum  === ""){
        this.setState({"idNumber_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight2_plh03")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      //------------------
      //validate birthDate---Multi Picker
      //------------------
      let yyyy = this.state.birthDateYear_text;
      let mmmm = this.state.birthDateMonth_text.length===1 ? "0"+this.state.birthDateMonth_text : this.state.birthDateMonth_text;
      let dddd = this.state.birthDateDay_text.length===1   ? "0"+this.state.birthDateDay_text   : this.state.birthDateDay_text;
      let isValidDate = this.isValidDate(this.state.birthDateYear_text,this.state.birthDateMonth_text,this.state.birthDateDay_text); //console.log("isValidDate="+isValidDate);
      if(isValidDate===false){
        this.setState({"birthDateDay_hasError" : true,"birthDateMonth_hasError" : true, "birthDateYear_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+this.NSInforString("RegisterLight2_plh04"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      let birthDate = yyyy+"-"+mmmm+"-"+dddd;
      let year = birthDate.length>=4 ? birthDate.substring(0, 4) : "";
      localStorage.setItem("birthYear",year);
      //console.log("this.state.birthDate="+this.state.birthDate);
      //console.log("birthDate           ="+birthDate);
      //++++++++++++++++++++
      //validate [HONEYMOON]
      //++++++++++++++++++++
      if(this.state.textField0.trim()!==""){
        //this.setState({"textField1_hasError" : true });
        if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      //++++++++
      //Continue
      //++++++++
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let email = "";
      try {email = parserObject_validatecustomer["email"]; }catch(err){;} if(email === null){email = "";}
      let newRegistrationFlow = "";
      try{ newRegistrationFlow = localStorage.getItem("newRegistrationFlow");}catch(err){console.log(methName+'err='+err);}

      //event.preventDefault();
      let parserObject_updateCustomerData_req = {};
      parserObject_updateCustomerData_req["step"]               = "2";                          //2
      parserObject_updateCustomerData_req["flow"]               = newRegistrationFlow;          //newCustomer, upgradeAccount, changeId, annualUpdate
      parserObject_updateCustomerData_req["firstName"]          = firstName;                    //Nikos
      parserObject_updateCustomerData_req["lastName"]           = lastName;                     //Menis
      parserObject_updateCustomerData_req["email"]              = email;                        //lala@lala.com
      parserObject_updateCustomerData_req["birthDate"]          = birthDate;                    //1970-01-01
      parserObject_updateCustomerData_req["idnum"]              = idnum;                        //ab12817829
      parserObject_updateCustomerData_req["recaptchaVerify"]    = api.isCaptchaEnabled ? JSON.stringify(this.recaptchaRef.getResponse()) : "";
      //XYZ
      localStorage.setItem("parserObject_updateCustomerData_req", JSON.stringify(parserObject_updateCustomerData_req));

      this.startSpinners();
      setTimeout(function() { //Start the timer
        //------------------
        //updateCustomerData
        //------------------
        wu_ProfileService
        .wu_updateCustomerData(parserObject_updateCustomerData_req)
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="RegisterLight2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          //this.stopSpinners();
          //-------------------
          //wu_validatecustomer
          //-------------------
          wu_ProfileService
          .wu_validatecustomer({})
          .then(res => {
            if(localStorage.getItem("curr_view").trim()!=="RegisterLight2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
            this.stopSpinners();
            localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

            //5A7,5A8(RegisterLight2-Next-Customer did not select BP)
            let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,res.customer);
            var idVerificationStatus = 0;
            try {idVerificationStatus = res.customer["idVerificationStatus"]; }catch(err){;} if(idVerificationStatus !== null && (typeof idVerificationStatus !== "undefined")) {}
            if(customerLevel === "FULL" && (idVerificationStatus === 1 || idVerificationStatus === null)){
              //+++++++++++++++
              //Goto Controller
              //+++++++++++++++
              localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
              history.push(wu_Utilities.getNavigationURLs("RegisterIdBoxSuccess")); //==> RegisterIdBoxSuccess
              this.stopSpinners();
              return;
            }

            //+++++++++++++++
            //Goto Controller
            //+++++++++++++++
            localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
            history.push(wu_Utilities.getNavigationURLs("RegisterLight3")); //btn_next_act xxx
          })
          .catch(err => {
            this.stopSpinners();
            console.log(methName+"err="+JSON.stringify(err));
            if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
            else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
          });
        })
        .catch(err => {
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });
      }.bind(this), 500);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="firstName"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "firstName"          : eventTMP,
        "firstName_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"firstName_hasError":true}); return; }
      if(eventTMP.length > 36){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstName.size")); this.setState({"firstName_hasError":true}); return; }
      if(eventTMP.trim().length + this.state.lastName.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstlastName.size")); this.setState({"firstName_hasError":true, "lastName_hasError":true}); return; }
      else                                                               { this.setState({"firstName_hasError":false, "lastName_hasError":false}); }
    }
    else if(stateVar==="lastName"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "lastName"          : eventTMP,
        "lastName_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"lastName_hasError":true}); return; }
      if(eventTMP.length > 36){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstName.size")); this.setState({"lastName_hasError":true}); return; }
      if(this.state.firstName.trim().length + eventTMP.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstlastName.size")); this.setState({"firstName_hasError":true, "lastName_hasError":true}); return; }
      else                                                                { this.setState({"firstName_hasError":false, "lastName_hasError":false}); }
    }
    else if(stateVar==="idNumber"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "idNumber"            : eventTMP,
        "idNumber_hasError"   : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"idNumber_hasError":true}); return; }
    }
    else{
      //console.log(stateVar+"-"+eventTMP);
      if(eventTMP===""){eventTMP=birthDate_dv;}
      this.setState({ [stateVar] : eventTMP });
      if(eventTMP!==""){this.setState({"birthDate_hasError" : true }); }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="firstName")                        { return wu_Utilities.offline_validate_firstName(val); }
    if(key==="lastName")                         { return wu_Utilities.offline_validate_lastName(val);  }

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  // importAll(r) {
  //   //return r.keys().map(r);
  //   let images = {};
  //   r.keys().map((item, index) => {
  //     images[item.replace('./', '')] = r(item);
  //     return "";
  //   });
  //   return images;
  // }
  //----------------------------------------------------------------------------------------------------
  //https://stackoverflow.com/questions/21188420/javascript-date-validation-not-validation-february-31
  isValidDate(year, month, day) {
    let methName = filename+"isValidDate ";
    if(api.print_logs){console.log(methName);}

    try{
      let year_int  = parseInt(year);
      let month_int = parseInt(month)-1;
      let day_int   = parseInt(day);
      var d = new Date(year_int, month_int, day_int);
      //console.log(methName+"d.getFullYear()="+d.getFullYear()+" year_int="+year_int);
      //console.log(methName+"d.getMonth()   ="+d.getMonth()+"    month_int="+month_int);
      //console.log(methName+"d.getDate()    ="+d.getDate()+"     day_int="+day_int);
      if (d.getFullYear() === year_int && d.getMonth() === month_int && d.getDate() === day_int) {
          return true;
      }
    }catch(err){
      console.log(methName+"err="+err)
      return false;
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  saveState(){
    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[CAMPAIGN]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog101_handleOpen(dialog_msg){
    this.setState({ "dialog101_isOpen" : true });
    this.setState({ "dialog101_msg"    : dialog_msg });
  }
  dialog101_handleClose(){
    this.setState({ "dialog101_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"RG1"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups bpdone----------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_bpdone_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_bpdone_isOpen" : true,
        "dialog_bpdone_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_bpdone_btn_ok(){
    let methName = filename+"dialog_bpdone_btn_ok ";
    if(api.print_logs){console.log(methName);}

    history.push(wu_Utilities.getNavigationURLs("Bills"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Specific------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
}
RegisterLight2.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(RegisterLight2Style)(RegisterLight2)
);
